module.exports = __webpack_public_path__ + "img/1.275959ac.png";